import type { Router } from 'vue-router'

let bootPosition = 0

function getHistoryPosition(): number {
  return (window.history.state as { position?: number } | null)?.position ?? 0
}

function initNavigationHistoryTracking(router: Router) {
  router.isReady().then(() => {
    bootPosition = getHistoryPosition()
  })
}

function canGoBackInApp(): boolean {
  return getHistoryPosition() > bootPosition
}

function goBackOrElse(router: Router, fallback: () => void) {
  if (canGoBackInApp()) {
    router.back()
  } else {
    fallback()
  }
}

export { initNavigationHistoryTracking, canGoBackInApp, goBackOrElse }
